<app-banner></app-banner>
<!-- <app-scroller></app-scroller> -->
<app-feature></app-feature>
<app-refer-and-earn></app-refer-and-earn>
<!-- <app-how-to-buy></app-how-to-buy> -->
<app-teams></app-teams>

<app-roadmap></app-roadmap>
<app-token-section></app-token-section>
<!-- <app-partners></app-partners> -->
<app-tokenomics></app-tokenomics>
<app-infra></app-infra>
<app-ai></app-ai>
<app-ready></app-ready>
<app-airdrop></app-airdrop>